import { ROUTES } from ".";
import {
    CalendarLtr24Regular,
    Document24Regular,
    HomePerson24Regular,
    TaskListLtr24Regular,
    Clock24Regular,
    Payment24Regular,
    BuildingMultiple24Regular,
    Home24Regular,
    Handshake24Regular,
    PersonArrowRight24Regular,
} from "@fluentui/react-icons";
import { useAuthDetailStore } from "../../stores/useAuthStore";
import { ROLES_CODE } from "../roles";

const KEYS_FEATURES_BACKEND = {
    expense_report: "expense_report",
    time_reporting: "time_reporting",
    telework: "telework",
};

export const BREADCRUMB_STRUCTURE = [
    {
        id: 1,
        name: "Accueil",
        link: ROUTES.home,
        icon: <HomePerson24Regular />,
        activated: true,
    },
    {
        id: 2,
        name: "Mes tâches",
        link: ROUTES.task_manager,
        icon: <TaskListLtr24Regular />,
        activated: true,
    },
    {
        id: 3,
        name: "Absences",
        link: ROUTES.leave,
        icon: <CalendarLtr24Regular />,
        activated: true,
    },
    {
        id: 4,
        name: `Suivi du temps`,
        key: KEYS_FEATURES_BACKEND.time_reporting,
        link: ROUTES.time_reporting.home,
        icon: <Clock24Regular />,
        activated: true,
    },
    {
        id: 8,
        name: `Télétravail`,
        key: KEYS_FEATURES_BACKEND.telework,
        link: ROUTES.remote_job.home,
        icon: <Home24Regular />,
        activated: true,
    },
    {
        id: 5,
        name: "Notes de frais",
        key: KEYS_FEATURES_BACKEND.expense_report,
        link: ROUTES.expenses.home,
        icon: <Payment24Regular />,
        activated: true,
    },

    {
        id: 6,
        name: "Documents RH",
        link: ROUTES.rh_document,
        icon: <Document24Regular />,
        activated: true,
    },
    {
        id: 7,
        name: "Mon établissement",
        link: ROUTES.annuaire,
        icon: <BuildingMultiple24Regular />,
        activated: true,
    },
];

export const generate_humberger_global = () => {
    const humberger = [...BREADCRUMB_STRUCTURE];

    const detail = useAuthDetailStore.getState()?.detail;
    const isRH = detail?.roles?.some((role) => role?.code === ROLES_CODE.hr);

    const format_humberger = humberger.map((item) => {
        switch (item?.key) {
            case KEYS_FEATURES_BACKEND.expense_report:
                return {
                    ...item,
                    activated:
                        detail?.features?.expense_report?.activated ?? true,
                };
            case KEYS_FEATURES_BACKEND.time_reporting:
                return {
                    ...item,
                    activated:
                        detail?.features?.time_reporting?.display_in_main_menu,
                };
            case KEYS_FEATURES_BACKEND.telework:
                return {
                    ...item,
                    activated: detail?.features?.telework?.activated,
                };

            default:
                return item;
        }
    });

    if (isRH) {
        format_humberger.push(
            {
                id: 8,
                name: "Onboarding",
                link: ROUTES.onboarding.home,
                icon: <Handshake24Regular />,
                activated: true,
            },
            {
                id: 9,
                name: "Offboarding",
                link: ROUTES.offboarding.home,
                icon: <PersonArrowRight24Regular />,
                activated: true,
            }
        );
    }

    // Simple tri pour mettre "Mon établissement" toujours en bas
    const sorted = format_humberger.sort((a, b) => {
        if (a.id === 7) return 1;
        if (b.id === 7) return -1;
        return 0;
    });
    return sorted;
};

export const BREADCRUMB_HUMBERGER_GLOBAL = generate_humberger_global;
